import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FileCheck2, ReceiptIndianRupee } from "lucide-react";
import "./PurchaseValidationModeSwitch.css";

const MODES = [
  {
    id: "po",
    label: "PO Number",
    description: "Vendor, PO items and rates",
    path: "/purchase-dashboard",
    icon: FileCheck2,
  },
  {
    id: "voucher",
    label: "Voucher Number",
    description: "Handwritten VN and grand total",
    path: "/purchase-dashboard/voucher",
    icon: ReceiptIndianRupee,
  },
];

export default function PurchaseValidationModeSwitch() {
  const location = useLocation();
  const navigate = useNavigate();
  const activeMode = location.pathname.includes("/purchase-dashboard/voucher") ? "voucher" : "po";

  return (
    <section className="purchase-mode-shell" aria-label="Purchase bill validation method">
      <div className="purchase-mode-copy">
        <span className="purchase-mode-eyebrow">Choose validation method</span>
        <strong>How should this bill be matched?</strong>
      </div>
      <div className="purchase-mode-tabs" role="tablist" aria-label="Purchase bill matching mode">
        {MODES.map((mode) => {
          const Icon = mode.icon;
          const active = activeMode === mode.id;
          return (
            <button
              key={mode.id}
              type="button"
              role="tab"
              aria-selected={active}
              className={`purchase-mode-tab ${active ? "is-active" : ""}`}
              onClick={() => !active && navigate(mode.path)}
            >
              <span className="purchase-mode-icon"><Icon size={18} /></span>
              <span>
                <b>{mode.label}</b>
                <small>{mode.description}</small>
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
